import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/right.png";
import ButtonLoader from "../../components/ButtonLoader";
import { forgotPassword, getAdminByEmail } from "../../middleware/backend_hepler";
import { toast, ToastContainer } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [emailExists, setEmailExists] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); 

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location.state]);

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getAdminByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!email) {
      setLoading(false);
      toast.error("Please enter your email");
      return;
    }

    if (!emailExists) {
      toast.error("Email is not registered. Please enter a valid email.");
      setLoading(false);
      return;
    }

    try {
      const response = await forgotPassword(email);
      setLoading(false);
      toast.success("Password reset link sent to your email.");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      setLoading(false);
      toast.error("Failed to send password reset link.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-box">
          <img src={logo} alt="Logo" className="logo" />
          <h2>Forgot Password</h2>
          <p>Enter your email to receive a password reset link.</p>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className={`form-group ${error ? "error" : ""}`}>
              <label htmlFor="email">Email</label>
              <div className={`input-container ${error ? "error" : ""}`}>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter email"
                  className="signup-field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {error && (
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className="info-icon"
                  />
                )}
              </div>
              {error && <p className="error-message">{error}</p>}
            </div>
            <div className="text-center">
              {!loading ? (
                <button type="submit">Send Link</button>
              ) : (
                <ButtonLoader />
              )}
              <p className="signup-text">
                Go back to{" "}
                <Link to="/login" className="signup-link">
                  Login.
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;